<div class="{{layoutClassName}}" style="position: relative;">
  <input type="text" name="inputNumberFormat" class="{{className}}"
    [(ngModel)]="displayValue" [readonly]="readonly" [placeholder]="placeholder"
    (focus)="onAmountFieldFocused($event)" (focusout)="onAmountFieldFocusedout($event)"
    (keypress)="numberOnly($event)">
    @if (showClearButton()) {
      <i
        class="pi pi-times closed-button"
        (click)="onClear()">
      </i>
    }
  </div>